import { CUSTOMERS } from '../../api/endpoints';

/** Build multipart FormData for POST/PUT /customers */
export function buildCustomerFormData(form, { includePassword = true } = {}) {
  const fd = new FormData();
  const append = (key, value) => {
    if (value === undefined || value === null || value === '') return;
    fd.append(key, value);
  };

  append('name', form.name?.trim());
  append('email', form.email?.trim());
  append('username', form.username?.trim());
  append('phone', form.phone?.trim());
  append('gender', form.gender);
  append('dob', form.dob);
  append('status_id', form.status_id);
  append('role', CUSTOMERS.ROLE_NAME);

  if (includePassword && form.password) {
    append('password', form.password);
    append('password_confirmation', form.password_confirmation || form.password);
  }

  if (form.avatar instanceof File) {
    fd.append('avatar_id', form.avatar);
  }

  return fd;
}

export function getCustomerStatusLabel(row) {
  return row?.status?.name ?? row?.status?.label ?? '—';
}

export function getCustomerTeamsLabel(row) {
  const teams = row?.teams;
  if (!Array.isArray(teams) || teams.length === 0) return '—';
  return teams.map((t) => t?.name).filter(Boolean).join(', ') || '—';
}

export function formatGender(gender) {
  switch (gender) {
    case 'M':
      return 'Male';
    case 'F':
      return 'Female';
    case 'O':
      return 'Other';
    default:
      return 'Not Specified';
  }
}
